module.exports = __webpack_public_path__ + "img/jumpilla-4.d76c62bc.jpg";